import React from "react";

import {
  IconChevronRight,
  IconSpeakerphone,
  IconMapPin,
  IconBriefcase,
  IconArrowNarrowRight,
  IconHome,
  IconClock,
  IconHeartbeat,
  IconCoffee,
  IconUsers,
  IconPlayerPlayFilled,
} from "@tabler/icons-react";
import { PiggyBank } from "lucide-react";

const Careers = () => {
  return (
    <div>
      <section className="mt-[71px] bg-[url(../images/banner-bg-2.png)] bg-cover bg-no-repeat md:mt-[87px] xl:mt-0">
        <div className="bg-primary bg-opacity-40 py-[52px] xl:pb-[130px]">
          <div className="container text-n8">
            <h3 className="h3 mb-2.5">Career at Cognity</h3>
            <ul className="flex flex-wrap items-center gap-2">
              <li>
                <a href="/" className="home-link">
                  Home
                </a>
              </li>
              <li className="flex items-center">
                <IconChevronRight size={24} /> {/* ✅ Tabler Icon */}
              </li>
              <li>
                <a href="/careers" className="home-link">
                  Career
                </a>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* <!-- ==================== Open Positions ==================== --> */}

      <section className="bg-n8">
        <div className="container">
          <div className="my-10 rounded-[30px] bg-n8 p-4 shadow-[0px_16px_30px_0px_rgba(42,33,99,0.25)] md:p-8 lg:px-[60px] lg:py-10 xl:my-0 xl:-translate-y-1/2" >
            <form className="flex flex-wrap items-center justify-between gap-4 md:flex-nowrap md:gap-6">
              <input
                className="w-full rounded-[30px] border border-n6 bg-light px-7 py-3 focus:outline-none"
                placeholder="Job title, level"
                type="text"
              />
              <button
                className="btn-primary shrink-0"
                style={{ backgroundColor: "rgb(0, 109, 178)", color: "white" }} // Applied to button background
              >
                Find Dream Job
                <span
                  className="flex items-center rounded-full bg-n8 p-1"
                  style={{ color: "rgb(0, 109, 178)" }}
                >
                  <IconChevronRight size={24} />
                </span>
              </button>
            </form>
          </div>
          <div className="mx-auto max-w-[1076px] pb-[60px] lg:mt-12 lg:pb-[120px] mt-0">
            <div className="mx-auto mb-6 max-w-[500px] text-center lg:mb-10" data-aos="fade-right">
              <h5 className="h5 mb-4" style={{ color: "rgb(0, 109, 178)" }}>
                Open Positions
              </h5>
              <h3 className="h3 mb-4 text-title">
                Come and join our fast growing team
              </h3>
              <p className="mx-auto text-para2">
                Our team is constantly expanding. We’re currently seeking
                candidates for the following vacant positions
              </p>
            </div>
            <div className="flex flex-col gap-6" data-aos="fade-left">
  {[
    { title: "Senior UX Designer", description: "As a Senior UX Designer, you will lead design projects and collaborate with cross-functional teams to create seamless user experiences." },
    { title: "Product Manager", description: "As a Product Manager, you will oversee product development from concept to launch, ensuring the product meets customer needs and company goals." },
    { title: "Data Scientist", description: "As a Data Scientist, you will analyze complex data sets and build models to help guide business decisions and improve product offerings." },
    { title: "Frontend Developer", description: "As a Frontend Developer, you will build user-facing features, ensuring high-quality code and a seamless, responsive experience." },
    { title: "Marketing Specialist", description: "As a Marketing Specialist, you will create and implement strategies to promote products and engage with customers, driving brand awareness." },
  ].map((job, index) => (
    <div
      key={index}
      className="career-appear-down py-4 shadow-[0px_8px_30px_0px_rgba(86,58,255,0.10)] px-4 sm:py-3 sm:px-6 max-w-[90%] border rounded shadow"
    >
      <div className="career-accordion flex cursor-pointer justify-between gap-2 duration-300 sm:gap-6">
        <div className="flex gap-4">
          <div>
            <span
              className="flex shrink-0 rounded-full p-4 text-primary md:p-6"
              style={{
                backgroundColor: "rgba(0, 109, 178, 0.2)",
                color: "rgb(0, 109, 178)",
              }}
            >
              <IconSpeakerphone size={35} className="rotate-[-30deg]" />
            </span>
          </div>
          <div>
            <p
              className="h4 mb-4 inline-block font-semibold"
              style={{ color: "rgb(0, 109, 178)" }}
            >
              {job.title}
            </p>
            {/* Added description here */}
            <p className="text-para mb-4">{job.description}</p>

            <div className="flex gap-7">
              <div className="flex items-center gap-1.5">
                <IconMapPin size={20} style={{ color: "rgb(0, 109, 178)" }} />
                <p className="text-para">Bangalore</p>
              </div>
              <div className="flex items-center gap-1.5">
                <IconBriefcase size={20} style={{ color: "rgb(0, 109, 178)" }} />
                <p className="text-para">Full Time</p>
              </div>
            </div>
            <div className="accordion-content h-0 overflow-hidden duration-300">
              <p className="l-text mt-4 opacity-80">
                As a {job.title} in the heart of Bangalore, you will play a pivotal role in creating intuitive and visually stunning user interfaces. You'll conduct in-depth user research, collaborate closely with cross-functional teams, and use your expertise to craft exceptional digital experiences that not only meet but exceed user expectations. Join us in shaping the future of user-centered design.
              </p>
            </div>
          </div>
        </div>
        <div>
          <button
            className="absolute right-4 top-4 flex h-12 w-12 shrink-0 items-center justify-center rounded-md border bg-primary/20 text-primary sm:static md:h-[60px] md:w-[60px]"
            style={{
              borderColor: "rgb(0, 109, 178)",
              backgroundColor: "rgba(0, 109, 178, 0.2)",
              color: "rgb(0, 109, 178)",
            }}
          >
            <IconArrowNarrowRight
              size={24}
              className="accordion-icon duration-300"
            />
          </button>
        </div>
      </div>
    </div>
  ))}
</div>

          </div>
        </div>
      </section>

      {/* <!-- =========== Our recruitment process ============ --> */}
      <section className="section bg-light">
        <div className="container">
          <div className="mx-auto mb-6 max-w-[738px] text-center lg:mb-10" data-aos="fade-right">
            <h5 className="h5 mb-2" style={{ marginTop: "-50px" }}>
              Our recruitment process
            </h5>
            <h3 className="h3 mb-2 text-title">
              What does our recruitment process look like?
            </h3>
            <p className="text-para2">
              We value your and our time. That's why we strive to make
              everything as efficient as possible. You can become part of the
              Rocketech team in just a few simple steps.
            </p>
          </div>
          <div className="grid grid-cols-12 gap-4" data-aos="fade-left">
            <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-3">
              <div className="flex flex-col items-center rounded-[20px] border border-n4 p-3 text-center duration-500 hover:bg-[rgb(0,109,178)] border-primary md:p-4 lg:p-5">
                <img
                  alt="icon"
                  loading="lazy"
                  width="180"
                  height="180"
                  decoding="async"
                  data-nimg="1"
                  src="assets/images/recruit-process-1.png"
                  className="transition-transform duration-300 hover:scale-105"
                  style={{ color: "transparent" }}
                />
                <h5 className="h5 text-title mt-3">Send Your CV</h5>
              </div>
            </div>
            <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-3">
              <div className="flex flex-col items-center rounded-[20px] border border-n4 p-3 text-center duration-500 hover:bg-[rgb(0,109,178)] border-primary md:p-4 lg:p-5">
                <img
                  alt="icon"
                  loading="lazy"
                  width="180"
                  height="180"
                  decoding="async"
                  data-nimg="1"
                  src="assets/images/recruit-process-2.png"
                  className="transition-transform duration-300 hover:scale-105"
                  style={{ color: "transparent" }}
                />
                <h5 className="h5 text-title mt-3">TA Manager Interview</h5>
              </div>
            </div>
            <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-3">
              <div className="flex flex-col items-center rounded-[20px] border border-n4 p-3 text-center duration-500 hover:bg-[rgb(0,109,178)] border-primary md:p-4 lg:p-5">
                <img
                  alt="icon"
                  loading="lazy"
                  width="180"
                  height="180"
                  decoding="async"
                  data-nimg="1"
                  src="assets/images/recruit-process-3.png"
                  className="transition-transform duration-300 hover:scale-105"
                  style={{ color: "transparent" }}
                />
                <h5 className="h5 text-title mt-3">Team Interviews</h5>
              </div>
            </div>
            <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-3">
              <div className="flex flex-col items-center rounded-[20px] border border-n4 p-3 text-center duration-500 hover:bg-[rgb(0,109,178)] border-primary md:p-4 lg:p-5">
                <img
                  alt="icon"
                  loading="lazy"
                  width="180"
                  height="180"
                  decoding="async"
                  data-nimg="1"
                  src="assets/images/recruit-process-4.png"
                  className="transition-transform duration-300 hover:scale-105"
                  style={{ color: "transparent" }}
                />
                <h5 className="h5 text-title mt-3">Offer</h5>
              </div>
            </div>
          </div>
        </div>
      </section>

      

     
    </div>
  );
};

export default Careers;
